import PropTypes from "prop-types";

import TabHeader from "./tab-header/TabHeader";

export default function StandardTabPanel({
  activeTab,
  tabList,
  headerBoxBackgroundColor,
  headerTabVariant,
  headerTabIndicatorSx,
  headerTabSx,
  children,
}) {
  if (!tabList?.length) return null;

  let activeIndex = tabList.findIndex((tab) => {
    return tab.key === activeTab;
  });

  return (
    <>
      <TabHeader
        tabList={tabList}
        tabValue={activeIndex}
        boxBackgroundColor={headerBoxBackgroundColor}
        tabVariant={headerTabVariant}
        tabIndicatorSx={headerTabIndicatorSx}
        tabsSx={headerTabSx}
      />
      {children}
    </>
  );
}

StandardTabPanel.propTypes = {
  initialTabValue: PropTypes.number,
  tabList: PropTypes.array,
  headerBoxBackgroundColor: PropTypes.string,
  headerTabVariant: PropTypes.string,
  headerTabIndicatorSx: PropTypes.object,
  headerTabSx: PropTypes.object,
};
